import { CatBadge } from 'components/blocks-components';
import { FeatureFlagProps, UserDetailsProps } from './types';

const sidePanelList = (
  userDetail?: UserDetailsProps,
  featureFlags?: FeatureFlagProps,
  serviceInsightCount?: number,
  buyAgainHide?: boolean
) => {
  const { isCspUser } = userDetail || {};
  const {
    PCC_HEADLESS_SERVICE_INSIGHTS_CUSTOMER_FLAG,
    PCC_BUY_AGAIN_HEADLESS_FLAG
  } = featureFlags || {};

  return {
    myEquipment: {
      name: 'myEquipment',
      label: 'SIS_EQUIP_LIST',
      tab_id: 0,
      ga_event_name: 'e_facetNav',
      ga_nltext: 'My Equipment',
      ga_context: 'Homepage Menu',
      isHide: false
    },
    serviceRecommendation: {
      name: 'serviceRecommendation',
      label: 'SERVICE_RECOMMENDATIONS',
      tab_id: 1,
      ga_event_name: 'e_facetNav',
      ga_nltext: 'service insights',
      ga_context: 'Homepage Menu',
      isHide: !(isCspUser && PCC_HEADLESS_SERVICE_INSIGHTS_CUSTOMER_FLAG),
      icon: serviceInsightCount > 0 ? <CatBadge isDot /> : null
    },
    recentlyViewed: {
      name: 'recentlyViewed',
      label: 'RECENTLY_VIEWED',
      tab_id: 2,
      ga_event_name: 'e_facetNav',
      ga_nltext: 'recently viewed',
      ga_context: 'Homepage Menu',
      isHide: false
    },
    buyAgain: {
      name: 'buyAgain',
      label: 'HOMEPAGE_BUY_AGAIN',
      tab_id: 3,
      ga_event_name: 'e_facetNav',
      ga_nltext: 'buy again',
      ga_context: 'Homepage Menu',
      isHide: !(PCC_BUY_AGAIN_HEADLESS_FLAG && isCspUser && !buyAgainHide)
    }
  };
};

export default sidePanelList;
